import React, {useEffect, useState} from "react";
import {Platform} from "../layouts/Platform";
import axios from "axios";
import {API_URL} from "../config";
import {getAuthToken} from "../functions/getAuthToken";
import {Box, Divider, Stack, Typography} from "@mui/material";
import {ContenutiBox} from "../components/Contenuti/ContenutiBox";
import {auth} from "../firebase/clientApp";
import {useUserStore} from "../store/userStore";
import {ContenutoVideo} from "../components/Contenuti/ContenutiBox/ContenutoVideo";

export const Podcast = () => {
  const [loading, setLoading] = React.useState(true)
  const [podcast, setPodcast] = React.useState([])
  const [link, setLink] = useState("")
  const {user} = useUserStore()

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      getPodcast()
    })
  }, [])

  const getPodcast = async () => {
    setLoading(true)
    let token = await getAuthToken()
    await axios.get(`${API_URL}/podcast`, {headers: {Authorization: token}})
      .then(res => {
        setLink(res.data.link)
        let m = res.data.podcast
        m.sort((a, b) => b.position - a.position)
        setPodcast(m)
      })
      .catch(err => console.log(err))
    setLoading(false)
  }

  return (
    <Platform>
      <Box>
        <Typography gutterBottom variant={'caption'}>
          *Contenuti, immagini e video hanno scopo formativo e sono ad esclusiva fruizione del personale della
          concessionaria. È vietato qualunque altro utilizzo che sia promozionale, pubblicitario o di qualunque altra
          tipologia di comunicazione.
        </Typography>
        <Stack py={2}>
          <Typography gutterBottom variant={'h5'}>
            <strong>Streamer</strong> - Il podcast dedicato ai Consulenti alla Vendita
          </Typography>
          <Typography gutterBottom variant={'body1'}>
            10’ per le notizie ed i fatti che stanno cambiando il modo di vendere e di intendere la
            mobilità
          </Typography>
        </Stack>
      </Box>
      <Box>
        {(!loading && podcast.length > 0) &&
          podcast.map((material, index) => (
            <ContenutiBox material={material} key={index} last={index === podcast.length - 1}/>
          ))}
      </Box>
    </Platform>
  )
}

